import './index.scss'
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import {Navigation } from 'swiper/modules';

Swiper.use([Navigation]);

document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.swiper-image-pepiniere', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});
